export const COMPANY = {
  legalName: "Madneel Ventures Private Limited",
  credit: "Sponsored by Madneel Ventures Private Limited",
  phone: "9870411327",
  phoneHref: "tel:+919870411327",
  email: "contact@niyatishivu.com",
  emailHref: "mailto:contact@niyatishivu.com",
  companyEmail: "contact@madneetventures.com",
  companyEmailHref: "mailto:contact@madneetventures.com",
};

export const SOCIAL_LINKS = {
  youtube: "https://www.youtube.com/channel/UCnvFWbcRrcDuqiS4LmsMSFA",
  youtubeSubscribe: "https://www.youtube.com/channel/UCnvFWbcRrcDuqiS4LmsMSFA?sub_confirmation=1",
  instagram: "https://www.instagram.com/niyati_shivu/",
  facebook: "https://www.facebook.com/profile.php?id=61590186560016",
};
